import { Grid, Typography } from '@mui/material';
import React from 'react';
import ReviewSlider1 from './Sliders/ReviewSlider1';

const TopReview = () => {
  return (
    <Grid container sx={{padding:'3%'}} spacing={2}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography variant='h5' sx={{color:'#2f6df6'}}>TOP REVIEW</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <ReviewSlider1 />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <ReviewSlider1 />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <ReviewSlider1 />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <ReviewSlider1 />
        </Grid>
    </Grid>
  );
};

export default TopReview;